import * as fromDatatype from '../datatype-library';

export interface bl_cms_label_post_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_guid: fromDatatype.GuidDataFieldInterface;
  post_hdr_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_cms_label_post_link_RowClass implements bl_cms_label_post_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_guid: fromDatatype.GuidDataFieldInterface;
  post_hdr_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
